(() => {
  if (customElements.get('nc-event-tabs')) return;
  customElements.define('nc-event-tabs', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.nav = this.querySelector('.nc-event-tabs__nav');
      if (!this.nav) return;
      this.tabs = [...this.nav.querySelectorAll('.nc-event-tabs__tab')];
      this.panels = [...this.querySelectorAll('[data-block-id]')];
      this.panels.forEach(panel => { panel.hidden = false; });
      // A body-level copy escapes theme overflow/transform containers.
      this.floating = document.createElement('div');
      this.floating.className = 'nc-event-tabs nc-event-tabs__floating';
      this.floating.hidden = true;
      const copy = this.nav.cloneNode(true);
      copy.removeAttribute('id');
      copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      this.floating.append(copy);
      document.body.append(this.floating);
      this.copyTabs = [...copy.querySelectorAll('.nc-event-tabs__tab')];
      [this.tabs, this.copyTabs].forEach(tabs => tabs.forEach((tab, index) => {
        tab.addEventListener('click', event => { event.preventDefault(); this.select(index); }, options);
      }));
      const schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      window.addEventListener('scroll', schedule, { ...options, passive: true });
      window.addEventListener('resize', schedule, options);
      this.observer = new ResizeObserver(schedule);
      this.observer.observe(this);
      this.observer.observe(this.nav);
      document.querySelectorAll('.section-header, sticky-header, .header-wrapper').forEach(el => this.observer.observe(el));
      this.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.select(index);
      }, options);
      this.update();
    }
    update() {
      if (!this.nav || !this.floating) return;
      let bottom = 0;
      document.querySelectorAll('.section-header, sticky-header, .header-wrapper').forEach(el => {
        const rect = el.getBoundingClientRect();
        const style = getComputedStyle(el);
        if (style.display !== 'none' && style.visibility !== 'hidden' && rect.top <= 1 && rect.bottom > 0) bottom = Math.max(bottom, rect.bottom);
      });
      const style = getComputedStyle(this);
      const manual = parseFloat(style.getPropertyValue(window.innerWidth <= 749 ? '--et-sticky-mobile' : '--et-sticky-desktop')) || 0;
      this.offset = Math.max(bottom, manual);
      for (let i = 0; i < style.length; i++) {
        const key = style[i];
        if (key.startsWith('--et-')) this.floating.style.setProperty(key, style.getPropertyValue(key));
      }
      this.floating.style.fontFamily = style.fontFamily;
      const rect = this.nav.getBoundingClientRect();
      const end = this.getBoundingClientRect().bottom;
      const pinned = rect.top < this.offset && end > this.offset + rect.height;
      this.floating.style.left = `${rect.left}px`;
      this.floating.style.width = `${rect.width}px`;
      this.floating.style.top = `${this.offset}px`;
      this.floating.hidden = !pinned;
      this.nav.style.visibility = pinned ? 'hidden' : '';
    }
    select(index) {
      [this.tabs, this.copyTabs].forEach(tabs => tabs.forEach((tab, i) => {
        if (i === index) tab.setAttribute('aria-current', 'location');
        else tab.removeAttribute('aria-current');
      }));
      const target = this.panels[index];
      if (!target) return;
      this.update();
      window.scrollTo({ top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - this.offset - this.nav.getBoundingClientRect().height - 12), behavior: 'instant' });
      this.update();
    }
    cleanup() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.floating?.remove();
      if (this.nav) this.nav.style.visibility = '';
    }
    disconnectedCallback() { this.cleanup(); }
  });
})();
